<section class="ai-asset-list-block">
  <h3>{{ block.totalLabel }}</h3>

  <article class="ai-asset-card" *ngFor="let asset of block.assets">
    <div class="ai-asset-heading">
      <div>
        <div class="ai-asset-id">{{ asset.assetId }}</div>
        <div class="ai-asset-title">
          {{ asset.assetType }}<span *ngIf="asset.assetCategory">, {{ asset.assetCategory }}</span>
        </div>
        <span class="ai-asset-criticality" [ngClass]="labelClass(asset.criticality)">
          {{ asset.criticality }}
        </span>
      </div>


    </div>

    <div class="ai-asset-meta">
      <span class="ai-meta-item"><em>Exposure</em><b>{{ asset.exposure }}</b></span>
      <span class="ai-meta-item"><em>Status</em><b>{{ asset.status }}</b></span>
      <span class="ai-meta-item" *ngIf="asset.location"><em>Location</em><b>{{ asset.location }}</b></span>
      <span class="ai-meta-item" *ngIf="asset.assignedTo"><em>Assigned</em><b>{{ asset.assignedTo }}</b></span>
      <span class="ai-meta-item" *ngIf="asset.owner"><em>Owner</em><b>{{ asset.owner }}</b></span>
    </div>

    <div class="ai-asset-relations">
      <ng-container *ngFor="let summary of [asset.risks, asset.frameworks, asset.actionItems, asset.tasks]">
        <div class="ai-asset-relation" *ngIf="summary">
          <span class="ai-relation-label">{{ summary.label }}</span>
          <ng-container *ngIf="summary.total > 0; else emptyRelation">
            <span class="ai-relation-id" *ngFor="let id of visibleIds(summary)">{{ id }}</span>
            <span class="ai-relation-more" *ngIf="hiddenCount(summary) > 0">
              +{{ hiddenCount(summary) }} more
            </span>
          </ng-container>
          <ng-template #emptyRelation>
            <span class="ai-relation-empty">None</span>
          </ng-template>
        </div>
      </ng-container>
    </div>
  </article>

  <button type="button" class="ai-more-link">More</button>
</section>
